import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggleBtn", "field", "input", "result"]
  static values = { price: Number }

  toggle() {
    this.fieldTarget.classList.toggle("hidden")
  }

  async validate(event) {
    const code = this.inputTarget.value.trim()
    if (!code) return

    const url = event.currentTarget.dataset.promoCodeUrlValue
    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "X-CSRF-Token": csrfToken,
          "Accept": "text/html"
        },
        body: `code=${encodeURIComponent(code)}`
      })

      const html = await response.text()
      this.resultTarget.innerHTML = html

      // Update total price if discount applied
      const discountEl = this.resultTarget.querySelector("[data-discount-percentage]")
      if (discountEl && this.hasPriceValue) {
        const discount = parseInt(discountEl.dataset.discountPercentage, 10)
        const discounted = Math.round(this.priceValue * (100 - discount) / 100)
        const totalEl = this.element.closest("form")?.querySelector("[data-total-price]")
        if (totalEl) {
          totalEl.textContent = `Rp ${discounted.toLocaleString("id-ID")}`
        }
      }
    } catch {
      this.resultTarget.innerHTML = '<p class="text-sm text-red-600">Unable to validate code. Please try again.</p>'
    }
  }
}
